import { useTranslation } from 'react-i18next';
import { dateFormat, DateTimeFormatter } from '../../../common/formatter/DateTimeFormatter';
import { formatDissolveDate } from './OverlayDissolveValues.utils';
import { SumTableEntryType } from './SumTable';

export const useLeftSumEntries = (
  isFollowUp: boolean,
  dissolveValue: number,
  date: Date | undefined,
  residualSubsidy: number,
  surcharge: number
) => {
  const { t } = useTranslation();
  const formattedDate = DateTimeFormatter.format(date, { format: dateFormat });
  const residualValue = residualSubsidy;
  const dissolveDate = formatDissolveDate(date);
  const initialDissolveValue = dissolveValue - residualValue;

  const standardEntries = [
    {
      label: t('dashboard.contractsOverlay.dissolveValues.initialDissolveValue'),
      value: initialDissolveValue,
      type: SumTableEntryType.Value,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.residualValueSubsidy'),
      value: residualValue,
      type: SumTableEntryType.Addition,
    },
    {
      label: dissolveDate,
      value: dissolveValue,
      type: SumTableEntryType.Sum,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.surcharge'),
      value: surcharge,
      type: SumTableEntryType.Addition,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.dissolveValueSumDate', {
        date: formattedDate,
      }),
      value: dissolveValue + surcharge,
      type: SumTableEntryType.Sum,
    },
  ];

  const followUpEntries = [
    {
      label: t('dashboard.contractsOverlay.dissolveValues.initialDissolveValue'),
      value: initialDissolveValue,
      type: SumTableEntryType.Value,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.residualValueSubsidy'),
      value: residualValue,
      type: SumTableEntryType.Addition,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.followUpBonus'),
      value: residualValue,
      type: SumTableEntryType.Subtraction,
    },
    {
      label: dissolveDate,
      value: initialDissolveValue,
      type: SumTableEntryType.Sum,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.surcharge'),
      value: surcharge,
      type: SumTableEntryType.Addition,
    },
    {
      label: t('dashboard.contractsOverlay.dissolveValues.dissolveValueSumDate', {
        date: formattedDate,
      }),
      value: initialDissolveValue + surcharge,
      type: SumTableEntryType.Sum,
    },
  ];

  return isFollowUp ? followUpEntries : standardEntries;
};
